import { useState, useEffect, useReducer } from "react";
import { toast } from "react-toastify";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const reducer = (state, action) => {
	if (action.type === "LOAD_WHATSAPPS") {
		const whatsApps = action.payload;

		return [...whatsApps];
	}

	if (action.type === "UPDATE_WHATSAPPS") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			// Merge em vez de substituir: eventos de create/update/restart/validate-token
			// não trazem assignedUsersCount/totalAttendants (issue #112), então um replace
			// total zeraria o badge de atendentes até o próximo reload da página.
			state[whatsAppIndex] = { ...state[whatsAppIndex], ...whatsApp };
			return [...state];
		}
		// Do not add new channels via socket — initial load already filters by user assignment
		return [...state];
	}

	if (action.type === "UPDATE_SESSION") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex].status = whatsApp.status;
			state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
			state[whatsAppIndex].qrcode = whatsApp.qrcode;
			state[whatsAppIndex].retries = whatsApp.retries;
			return [...state];
		} else {
			return [...state];
		}
	}

	if (action.type === "DELETE_WHATSAPPS") {
		const whatsAppId = action.payload;

		const whatsAppIndex = state.findIndex(s => s.id === whatsAppId);
		if (whatsAppIndex !== -1) {
			state.splice(whatsAppIndex, 1);
		}
		return [...state];
	}

	if (action.type === "RESET") {
		return [];
	}
};

const useWhatsApps = () => {
	const [whatsApps, dispatch] = useReducer(reducer, []);
	const [loading, setLoading] = useState(true);
	
	const fetchWhatsApps = async () => {
		try {
			setLoading(true);
			const { data } = await api.get("/whatsapp/");
			dispatch({ type: "LOAD_WHATSAPPS", payload: data });
			setLoading(false);
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	useEffect(() => {
		fetchWhatsApps();
	}, []);

	useEffect(() => {
		const socket = openSocket();

		const onWhatsapp = data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
			} else if (data.action === "delete") {
				dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
			}
		};
		const onWhatsappSession = data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_SESSION", payload: data.session });
			}
		};
		const onChannelTransfer = data => {
			const { fromChannelName, toChannelName, ticketsTransferred, groupsTransferred, groupsSkipped } = data;
			const total = (ticketsTransferred || 0) + (groupsTransferred || 0);
			const skippedMsg = groupsSkipped > 0 ? ` · ${groupsSkipped} grupo(s) ignorado(s)` : "";
			toast.info(
				`Canal transferido: ${fromChannelName} → ${toChannelName} · ${total} ticket(s)${skippedMsg}`,
				{ autoClose: 7000 }
			);
		};

		socket.on("whatsapp", onWhatsapp);
		socket.on("whatsappSession", onWhatsappSession);
		socket.on("channelTransfer", onChannelTransfer);

		return () => {
			socket.off("whatsapp", onWhatsapp);
			socket.off("whatsappSession", onWhatsappSession);
			socket.off("channelTransfer", onChannelTransfer);
		};
	}, []);

	return { whatsApps, loading, fetchWhatsApps };
};

export default useWhatsApps;
